import React, { useContext, useState } from "react";
import { withRouter, useHistory } from "react-router-dom";
import AlertContext from "../../context/alert/AlertContext";
import CardContext from "../../context/card/CardContext";

const UnregActionMenu = () => {
  const alertContext = useContext(AlertContext);
  const cardContext = useContext(CardContext);

  const { clearAlerts } = alertContext;
  const { loaded, selectedCard } = cardContext;

  const history = useHistory();

  const backHome = () => {
    clearAlerts();
    localStorage.removeItem("token");
    console.log("Back Home....");
    history.push("/");
  };

  const [toggleMenu, setToggleMenu] = useState(false);

  const menuToggle = () => {
    setToggleMenu(!toggleMenu);
  };

  return (
    <aside id="action-menu" className="unregAction">
      <div className="unregAction__title">
        RELOAD CARD NO. {loaded && selectedCard && selectedCard.serialNumber}
        <button className="unregAction__menu" onClick={menuToggle}>
          {toggleMenu ? (
            <i className="fas fa-times"></i>
          ) : (
            <i className="fas fa-bars"></i>
          )}
        </button>
      </div>
      <ul
        className={
          toggleMenu ? "unregAction__list__active" : "unregAction__list"
        }
      >
        {/* <li>
          <NavLink
            to="#"
            onClick={() => clearAlerts()}
            className="unregAction__list__checked"
          >
            <i className="fas fa-money-check"></i> Reload Q Card
          </NavLink>
        </li> */}
        {/* <li>
          <NavLink
            to="/unreg-cart"
            onClick={() => clearAlerts()}
            activeClassName="unregAction__list__checked"
          >
            <i className="fas fa-shopping-cart"></i> Cart
          </NavLink>
        </li> */}
      </ul>
      <input
        className={
          toggleMenu ? "unregAction__button__active" : "unregAction__button"
        }
        onClick={backHome}
        type="button"
        value="BACK HOME"
      ></input>
    </aside>
  );
};

export default withRouter(UnregActionMenu);
